import React from 'react';
import { useField } from 'formik';
import Label from './Label';
import Error from './Error';
import _ from 'lodash';
import { Input } from 'reactstrap';

const TextField = ({
  name,
  readOnly,
  className = 'form-group col-md-6',
  label,
  required,
  inputProps = { className: 'form-control' },
  labelProps = {},
  validate = () => undefined,
  upperCase = false,
  description = '',
  maxLength = 50
}) => {
  const [field, meta] = useField({ name, validate });
  const onChange = e => {
    let value = e.target.value;
    if (upperCase) value = _.toUpper(value);
    field.onChange(field.name)(value);
  };
  return (
    <div className={className}>
      <Label htmlFor={name} required={required} {...labelProps}>
        {label}
      </Label>
      <Input
        {...field}
        {...inputProps}
        value={field.value || ''}
        onChange={onChange}
        required={required}
        readOnly={readOnly}
        maxLength={maxLength}
        invalid={meta.error && meta.touched}
      />
      {description ? <small className='form-text text-secondary'>{description}</small> : null}
      <Error name={name}/>
    </div>
  );
};
export default TextField;
